import { defineStore } from 'pinia'
import { ENDPOINT_URL, getHeaders } from '../helpers/api'

const hotelId = import.meta.env.VITE_APP_HOTEL_ID
const endpoints = {
  sendEmail: `${ENDPOINT_URL}/hotel/${hotelId}/send-email`,
}

export const useContactUsStore = defineStore('contactUs', {
  state: () => ({}),
  actions: {
    sendQuery(query: any) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        const headers = getHeaders()
        const request = await useLazyFetch(endpoints.sendEmail, {
          method: 'POST',
          headers,
          body: query,
        })

        if (request.data.value.data.success)
          resolve(true)
        else reject(new Error('Error happened'))
      })
    },
  },
})
